import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderRo = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <HighlightedText
            text="Obțineți bonusul dumneavoastră"
            highlights={[
                { word: 'Obțineți' },
                { word: 'bonusul' },
                { word: 'dumneavoastră' },
            ]}
            breakAfterWords={isDesktop ? [] : ['bonusul']}
            className={common.text_header}
        />
    )
}

export const TextLandRo = () => {
    return (
        <HighlightedText
            text="325% Bonus + 400 ROTIRI GRATUITE"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['Bonus']}
            className={styles.text_content}
        />
    )
}
